import { render, staticRenderFns } from "./moreInformation.vue?vue&type=template&id=60d68c67&scoped=true&"
import script from "./moreInformation.vue?vue&type=script&lang=js&"
export * from "./moreInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d68c67",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VCarousel,VCarouselItem,VProgressLinear})
